import "antd/lib/form/style";
import _Form from "antd/lib/form";
import { connect } from 'dva';
import CI0302C from '../../components/CI/CI0302/index';
function mapDispatchToProps(_ref) {
  var ci0302Info = _ref.ci0302Info;
  return {
    ci0302Info: ci0302Info
  };
}
var CI0302R = _Form.create()(CI0302C);
export default connect(mapDispatchToProps)(CI0302R);